<template>
  <div class="content">
    <div class="response_table">
      <table>
        <thead style="height: 50px; flex:0; display: inline-block">
        <tr>
          <th scope="col">
            {{ translate('tariffication.has_service') }}
          </th>
          <th scope="col">
            {{ translate('tariffication.service_type') }}
          </th>
          <th scope="col">
            {{ translate('tariffication.service_descr') }}
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(service, key) in services" :key="key" :class="{ has_service: service.id !== null }">
          <td :data-label="translate('tariffication.has_service')">
            {{ service.id ? "Yes":"No" }}
          </td>
          <td :data-label="translate('tariffication.service_type')">
            {{ service.service_id }}
          </td>
          <td :data-label="translate('tariffication.service_descr')">
            {{ service.name }}
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>


export default {
    name: "TariffServices",
    props: ['services'],
    data() {
        return {

        }
    },
    methods: {
    }
}
</script>
<style lang="scss" scoped>

.response_table {
    padding: 0;

    table {
        .has_service {
            background-color: #41b88330;
        }

        .status {
            width: 40px;
            vertical-align: middle;
        }

        .active {
            width: 70px;
        }

        tbody {
            .link {
                color: black;
            }
        }
    }

    table tr {
        background-color: white;

        &:hover {
            background-color: #f1f1f1;
        }
    }
}
</style>
